import React from 'react'
import { Card } from 'components/Card'
import JobViewModel from '../JobViewModel'
import { JobProgressionCardContent } from '../JobProgressionCard'
import { observer } from 'mobx-react'
import EmptyTaskList from '../TasksCard/EmptyTaskList'
import ProgressBar from 'components/ProgressBar'
import RoomCard from '../RoomCard'
import { PendingSchedulingContent } from '../ConsultationCallCard'

interface Props {
  vm: JobViewModel
}

export default observer(function JobProgressionAndConsultationCard({
  vm,
}: Props) {
  const completed = vm.job.completed

  return (
    <>
      <Card>
        <JobProgressionCardContent vm={vm} />
      </Card>
      {!completed && (
        <>
          {vm.consultationIsPendingScheduling ? (
            <Card>
              <PendingSchedulingContent vm={vm} />
            </Card>
          ) : (
            <RoomCard
              vm={vm.roomVM}
              titleContent={
                completed ? (
                  <>Job Completed</>
                ) : (
                  <>Prepare for the consultation</>
                )
              }
              descriptionContent={
                completed ? (
                  <>
                    Start another call with the client, or proceed to complete
                    the job.
                  </>
                ) : (
                  <>
                    Schedule a call time with the client before starting the
                    consultation.
                  </>
                )
              }
              progressBar={
                completed && (
                  <>
                    <ProgressBar key={1} bars={[{ progress: 100 }]} />,
                    <EmptyTaskList key={2} />,
                  </>
                )
              }
              // buttonGroup={}
            />
          )}
        </>
      )}
    </>
  )
})
